const UserGroupsTab = () => {};

export default UserGroupsTab;
